import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { ClickableText } from '@/components/shared/clickableText';
import { CopyToClipboardWrapper } from '../buttons/copyToClipboardButton';
import { OverflowTooltip } from '../tooltips/overflowTooltip';
export const TextDetailsTuple = t0 => {
  const $ = _c(17);
  const {
    primaryProp,
    onPrimaryClick,
    secondaryProp,
    onSecondaryClick,
    enableSameValue: t1,
    sameColor: t2,
    copyable: t3
  } = t0;
  const enableSameValue = t1 === undefined ? false : t1;
  const sameColor = t2 === undefined ? false : t2;
  const copyable = t3 === undefined ? false : t3;
  const t4 = copyable ? undefined : "4px";
  let t5;
  if ($[0] !== t4) {
    t5 = {
      gap: t4,
      overflow: "hidden"
    };
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== copyable || $[3] !== onPrimaryClick || $[4] !== primaryProp) {
    t6 = <PrimaryProp onClick={onPrimaryClick} primaryProp={primaryProp} copyable={copyable} />;
    $[2] = copyable;
    $[3] = onPrimaryClick;
    $[4] = primaryProp;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== copyable || $[7] !== enableSameValue || $[8] !== onSecondaryClick || $[9] !== primaryProp || $[10] !== sameColor || $[11] !== secondaryProp) {
    t7 = <SecondaryProp onClick={onSecondaryClick} secondaryProp={secondaryProp} primaryProp={primaryProp} enableSameValue={enableSameValue} sameColor={sameColor} copyable={copyable} />;
    $[6] = copyable;
    $[7] = enableSameValue;
    $[8] = onSecondaryClick;
    $[9] = primaryProp;
    $[10] = sameColor;
    $[11] = secondaryProp;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <Stack sx={t5}>{t6}{t7}</Stack>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
const PrimaryProp = t0 => {
  const $ = _c(4);
  const {
    primaryProp,
    onClick,
    copyable
  } = t0;
  if (!primaryProp) {
    return null;
  }
  let t1;
  if ($[0] !== copyable || $[1] !== onClick || $[2] !== primaryProp) {
    t1 = !copyable ? <OverflowTooltip text={primaryProp} onClick={onClick} /> : <CopyToClipboardWrapper textToCopy={primaryProp}><OverflowTooltip text={primaryProp} onClick={onClick} /></CopyToClipboardWrapper>;
    $[0] = copyable;
    $[1] = onClick;
    $[2] = primaryProp;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const SecondaryProp = t0 => {
  const $ = _c(13);
  const {
    secondaryProp,
    primaryProp,
    onClick,
    enableSameValue,
    sameColor,
    copyable
  } = t0;
  if (!secondaryProp || !enableSameValue && primaryProp === secondaryProp) {
    return null;
  }
  const t1 = primaryProp && !sameColor ? "var(--mui-palette-text-secondary) !important" : "text.primary";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      color: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const colorSx = t2;
  let t3;
  if ($[2] !== colorSx || $[3] !== onClick || $[4] !== primaryProp) {
    t3 = (text, ref) => <ClickableText ref={ref} variant={primaryProp ? "body2" : "subtitle1"} className="truncate" sx={colorSx} onClick={onClick}>{text}</ClickableText>;
    $[2] = colorSx;
    $[3] = onClick;
    $[4] = primaryProp;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClick || $[7] !== secondaryProp || $[8] !== t3) {
    t4 = <OverflowTooltip text={secondaryProp} onClick={onClick} renderContent={t3} />;
    $[6] = onClick;
    $[7] = secondaryProp;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const content = t4;
  if (!copyable) {
    return content;
  }
  let t5;
  if ($[10] !== content || $[11] !== secondaryProp) {
    t5 = <CopyToClipboardWrapper textToCopy={secondaryProp}>{content}</CopyToClipboardWrapper>;
    $[10] = content;
    $[11] = secondaryProp;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};